.map-container {
  height: 400px;
  width: 100%;
  margin: 0;
  border-radius: 8px;
  overflow: hidden;
}

.map-wrapper {
  margin: 0;
  position: relative;
}

.legend {
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #555;
  background: rgba(255, 255, 255, 0.95);
  padding: 8px 12px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(4px);
  z-index: 1000;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.legend-gradient {
  width: 80px;
  height: 8px;
  border-radius: 4px;
  background: linear-gradient(to right, hsl(25, 60%, 65%), hsl(0, 90%, 30%));
  margin: 0 4px;
}

.legend-label {
  font-size: 11px;
  color: var(--body-text);
  font-weight: 600;
  min-width: 12px;
  text-align: center;
}

.hover-only-marker {
  pointer-events: auto !important;
  cursor: default !important;
}

.hover-only-marker:hover {
  cursor: default !important;
}
